export default "__VITE_ASSET__xdWgdX1z__"